<script>
  import Switch from "./Switch.svelte"
  import { commandsData } from "../assets/data"

  let commandBind = ""
  let timeoutBind = 150
  let isMultiLineActiveBind = false
  let shouldTypeBind = true

  function addCommand() {
    const generateCommand = (line = commandBind) => ({ line, timeout: timeoutBind, path: "", shouldType: shouldTypeBind })

    if (isMultiLineActiveBind) {
      const _commands = commandBind.split("\n")

      _commands.forEach((_command) => {
        const command = generateCommand(_command)
        $commandsData = [...$commandsData, command]
      })
    } else {
      const command = generateCommand()
      $commandsData = [...$commandsData, command]
    }

    commandBind = ""
  }

  function removeCommand(indexToRemove) {
    $commandsData = $commandsData.filter((_, i) => i !== indexToRemove)
  }
</script>

<div class="flex flex-col gap-2 w-full lg:w-4/6 lg:mx-auto">
  <!-- Header -->
  <div class="flex gap-2 p-2 bg-white drop-shadow-xl rounded-lg">
    <div class="flex gap-2 w-full">
      <div class="header w-2/6">Path</div>
      <div class="header w-full">Command</div>
    </div>
    <div class="flex gap-2 justify-between w-1/4">
      <div class="header w-1/3">Typing Animation</div>
      <div class="header w-1/3">Timeout (ms)</div>
      <div class="header w-1/3">+/-</div>
    </div>
  </div>
  <!-- Commands -->
  {#each $commandsData as command, index}
    <div class="flex gap-2 p-2 bg-white drop-shadow-xl rounded-lg">
      <div class="flex gap-2 w-full">
        <input type="text" bind:value={command.path} class="command-input w-2/6 text-slate-700" />
        <input type="text" bind:value={command.line} class="w-full command-input" />
      </div>
      <div class="flex gap-2 justify-between w-1/4">
        <Switch bind:isChecked={command.shouldType} />
        <div class="center w-1/3">
          <input type="text" class="timeout-input" bind:value={command.timeout} />
        </div>
        <button class="center border-none w-1/3" on:click={() => removeCommand(index)}>
          <img class="icon" src="/images/minus.svg" width="24" alt="minus icon" />
        </button>
      </div>
    </div>
  {/each}
  <!-- New Command -->
  <div class="p-2 bg-white w-full rounded-lg">
    <div class="flex gap-2">
      <textarea
        bind:value={commandBind}
        type="text"
        class="small-text !text-black border-none bg-gray-100 p-2 rounded-md w-full"
        placeholder="git commit --amend"
      />
      <div class="flex self-center justify-between w-1/4">
        <Switch bind:isChecked={shouldTypeBind} />
        <div class="center w-1/3">
          <input type="text" class="timeout-input" bind:value={timeoutBind} />
        </div>
        <button class="center border-none w-1/3" on:click={addCommand}>
          <img class="icon" src="/images/plus.svg" width="26" alt="plus icon" />
        </button>
      </div>
    </div>
    <!-- Extra options -->
    <div class="flex flex-row items-center mt-2">
      <Switch bind:isChecked={isMultiLineActiveBind} />
      <span class="small-text ml-2 outline-none text-gray-900">Multiline</span>
    </div>
  </div>
</div>

<style lang="postcss" scoped>
  .icon {
    width: 20px;
    min-width: 20px;
  }

  .small-text {
    @apply text-sm font-medium dark:text-gray-400;
  }

  .header {
    @apply text-xs font-bold self-center;
  }

  .center {
    @apply flex justify-center items-center;
  }
</style>
